/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.requests.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.auth',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.permissions',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.userPreferences',
  'acme.view.application.orders.requests.modals.removeOrderRequest.controllers'
])

.controller('OrdersRequestsListController',  ['$scope', '$state', '$timeout', '$uibModal', '$filter', 'HelpersService', 'ApiService', 'ValidateService', 'AuthService', 'PermissionsService', 'GridStateFactory', 'GridDefinitionFactory', 'UserPreferencesService', function($scope, $state, $timeout, $uibModal, $filter, HelpersService, ApiService, ValidateService, AuthService, PermissionsService, GridStateFactory, GridDefinitionFactory, UserPreferencesService) {

    $scope.ordersRequestsList = {

      model: [],

      // Dropdown
      selectStatus: [
        { name: 'all', label: 'All Statuses' },
        { name: 'OPEN', label: 'Open' },
        { name: 'CANCELLED', label: 'Cancelled' },
        { name: 'COMPLETE', label: 'Complete' }
      ],
      selectPaymentStatus: [
        { name: 'all', label: 'All payment statuses' },
        { name: 'NO_ORDERS_YET', label: 'No orders yet' },
        { name: 'NOT_PAID', label: 'Not Paid' },
        { name: 'PARTIALLY_PAID', label: 'Partially paid' },
        { name: 'PAID_IN_FULL', label: 'Paid in full' },
        { name: 'REFUNDED', label: 'Refunded' }
      ],

      // Query builder
      lastSearchQuery: '',
      searchQuery: '',
      isSearching: false,
      queryStatus: {},
      queryPaymentStatus: {},

      // All Grid
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      viewId: '',
      gridName: $state.current.name+'.grid0',
      optionsOverride: {
        enableGridMenu: true,
        data: 'ordersRequestsList.model',
        rowHeight: 40,
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.ordersRequestsList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.ordersRequestsList.onDataGridSortChange(grid, columns);
          },
          onDblClick: function (item) {
            $scope.ordersRequestsList.onDblClick(item);
          },
          remove: function (item) {
            $scope.ordersRequestsList.remove(item);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'Id'
          },
          {
            field: 'organizationName',
            displayName: 'Organization'
          },
          {
            field: 'organizationContactDisplay',
            displayName: 'Organization Contact',
            colId: 'orderRequestContact'
          },
          {
            field: 'internalContactDisplay',
            displayName: 'Internal Contact',
            colId: 'orderRequestInternalContact'
          },
          {
            field: 'orderRequestStatus',
            displayName: 'Status'
          },
          {
            field: 'payment.status',
            displayName: 'Payment Status'
          },
          {
            field: 'orderRequestTotal',
            displayName: 'Request Total',
            cellRenderer: function(params) {
              return params.valueFormatted || 0;
            },
            cellFilter: 'currency',
            cellFormatter: function(item) {
              return $filter('currency')(item.value);
            }
          },
          {
            field: 'totalBalanceDue',
            displayName: 'Balance Due',
            cellRenderer: function(params) {
              return params.valueFormatted || 0;
            },
            cellFilter: 'currency',
            cellFormatter: function(item) {
              return $filter('currency')(item.value || 0);
            }
          }
        ]
      },

      removeModal: {},
      dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

      init: function() {
        this.initSelectData();

        $scope.$emit('Application::contentTitleChange', {
          title: 'Order Requests',
          buttonRight: {
            label: 'Create Order Request',
            permissions: 'ORDER_REQUEST_CREATE',
            action: function() {
              $scope.ordersRequestsList.create();
            }
          }
        });

        if (PermissionsService.check('ORDER_REQUEST_UPDATE') || PermissionsService.check('ORDER_REQUEST_OWNER_VIEW')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'edit',
            displayName: 'Edit',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.ordersRequestsList.optionsOverride.appScopeProvider.onDblClick(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.id }}</span></a></div>',
            template: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a>View</a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false
          });
        }

        if (PermissionsService.check('ORDER_REQUEST_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            width: 80,
            onCellNavClick: function(row, col) {
              $scope.ordersRequestsList.optionsOverride.appScopeProvider.remove(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row)">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
            template: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false
          });
        }

        this.initDateFormats();

        this.viewId = $state.current.name;
        this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);
        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
      },

      initData: function() {
        var self = $scope.ordersRequestsList,
            props = self.gridDefinition.getGridState();

        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getOrdersRequestsList();
      },

      initSelectData: function() {
        this.queryStatus = this.selectStatus[0];
        this.queryPaymentStatus = this.selectPaymentStatus[0];
      },

      initDateFormats: function() {
        var self = $scope.ordersRequestsList;

        self.optionsOverride.columnDefs.push({
          field: 'createdOn',
          displayName: 'Date Created',
          visible: false,
          cellFilter: 'date: "'+ self.dateTimeFormat +'"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, self.dateTimeFormat);
          }
        });

        self.optionsOverride.columnDefs.push({
          field: 'updatedOn',
          displayName: 'Last modified',
          visible: false,
          cellFilter: 'date: "'+ self.dateTimeFormat +'"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, self.dateTimeFormat);
          }
        });
      },

      updateData: function() {
        this.gridState.setPropertyValue('status', (this.queryStatus.name === 'all' ? '' : this.queryStatus.name));
        this.gridState.setPropertyValue('paymentStatus', (this.queryPaymentStatus.name === 'all' ? '' : this.queryPaymentStatus.name));
        $scope.$broadcast('DataGrid::Search', {name: this.gridName});
      },

      query: function() {
        if (this.searchQuery !== this.lastSearchQuery) {
          this.isSearching = true;
          this.gridState.setPropertyValue('search', this.searchQuery);
          this.lastSearchQuery = this.searchQuery;
          this.updateData();
        }
      },

      getOrdersRequestsList: function() {
        var props = this.gridState.getGridState();
            user = AuthService.getCookie('user');

        if (PermissionsService.check('ORDER_REQUEST_OWNER_VIEW')) {
          props = angular.extend({userId: user.id}, props);
        }

        ApiService.orders.requests.list(props).then(this.success.init, this.error.init);
      },

      create: function() {
        $state.go('application.orders.requests.create');
      },

      remove: function(item) {
        var self = $scope.ordersRequestsList;
        if (PermissionsService.check('ORDER_REQUEST_DELETE')) {
          self.removeModal = $uibModal.open({
            templateUrl: 'views/application/views/orders/requests/modals/removeOrderRequest/removeOrderRequest.tpl.html',
            size: 'md',
            controller: 'OrdersRequestsModalsRemoveOrderRequestController',
            resolve: {
              OrderRequest: function () {
                return ApiService.orders.requests.detail(item.entity.id);
              }
            }
          });

          self.removeModal.result.then(function () {
            ApiService.orders.requests.remove({id: item.entity.id}).then(self.success.remove, self.error.remove);
          }, function () {
            // Do nothing
          });
        }
      },

      getContactDisplayName: function(contact) {
        var r = '';
        if (contact) {
          if (contact.firstName) {
            r =  contact.firstName;
            if (contact.lastName) {
              r =  r + ' ' + contact.lastName;
            }
            if (contact.primary) {
              r =  r + ' (primary)';
            }
          } else if (contact.email || contact.userName) {
            r =  (contact.email || contact.userName);
          }
        }

        return r;
      },

      getStatusFromName: function(types, name) {
        var r = '',
            type;
        if (types instanceof Array && name) {
          types.forEach(function(type) {
            if (type.name === name) {
              r = type.label || '';
            }
          });
        }
        return r;
      },

      processOrderRequests: function(orderRequests) {
        var i, ii;

        for (i=0, ii=orderRequests.length; i < ii; i++) {
          if (orderRequests[i].orderRequestContact) {
            orderRequests[i].organizationContactDisplay = this.getContactDisplayName(orderRequests[i].orderRequestContact);
          }
          if (orderRequests[i].orderRequestInternalContact) {
            orderRequests[i].internalContactDisplay = this.getContactDisplayName(orderRequests[i].orderRequestInternalContact);
          }
          if (orderRequests[i].payment && orderRequests[i].payment.status) {
            orderRequests[i].payment.status = this.getStatusFromName(this.selectPaymentStatus, orderRequests[i].payment.status);
          }
          if (orderRequests[i].orderRequestStatus) {
            orderRequests[i].orderRequestStatus = this.getStatusFromName(this.selectStatus, orderRequests[i].orderRequestStatus);
          }
        }

        return orderRequests;
      },

      success: {
        init: function(response) {
          var self = $scope.ordersRequestsList;
          self.model = self.processOrderRequests(response.data.payload.list);
          self.isSearching = false;
          self.gridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
          }, 10);
        },
        remove: function(response) {
          var self = $scope.ordersRequestsList;
          self.getOrdersRequestsList();
        }
      },

      error: {
        init: function(response) {},
        remove: function(response) {}
      },

      onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
        var self = $scope.ordersRequestsList;
        self.gridState.updateGridState(newPageNumber, newPageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if (sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getOrdersRequestsList();
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.ordersRequestsList,
            data = columns[0];

        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        self.getOrdersRequestsList();
      },

      onDblClick: function(item) {
        if (PermissionsService.check('ORDER_REQUEST_UPDATE') || PermissionsService.check('ORDER_REQUEST_OWNER_VIEW')) {
          $state.go('application.orders.requests.edit', {id: item.entity.id});
        }
      }

    };

    $scope.ordersRequestsList.init();

}]);
